import { render, staticRenderFns } from "./KoenenStandardization.vue?vue&type=template&id=6b4219c0&"
import script from "./KoenenStandardization.vue?vue&type=script&lang=js&"
export * from "./KoenenStandardization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports